module.exports = __webpack_public_path__ + "img/2.b0720ad5.png";